import { useRef, useState } from "react";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Edit, MoreVert, Publish, Cancel } from "@mui/icons-material";

// ----------------------------------------------------------------------

export default function MoreMenu({
  userRole,
  setOpenEditDialog,
  setOpenPublishDialog,
  setOpenCancelDialog,
  setRow,
  status,
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <MoreVert />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {status !== "published" && (
          userRole?.includes("Edit") && (
            <MenuItem
              onClick={() => {
                setOpenEditDialog(true);
                setRow();
                setIsOpen(false);
              }}
              sx={{ color: "text.secondary" }}
            >
              <ListItemIcon>
                <Edit />
              </ListItemIcon>
              <ListItemText
                primary="Edit"
                primaryTypographyProps={{ variant: "body2" }}
              />
            </MenuItem>
          )
        )}

        {status !== "published" && (
          userRole?.includes("Edit") && (
            <MenuItem
              sx={{ color: "text.secondary" }}
              onClick={() => {
                setOpenPublishDialog(true);
                setRow();
                setIsOpen(false);
              }}
            >
              <ListItemIcon>
                <Publish />
              </ListItemIcon>
              <ListItemText
                primary="Publish"
                primaryTypographyProps={{ variant: "body2" }}
              />
            </MenuItem>
          )
        )}

        {
          userRole?.includes("Delete") && (
            <MenuItem
              sx={{ color: "text.secondary" }}
              onClick={() => {
                setOpenCancelDialog(true);
                setRow();
                setIsOpen(false);
              }}
            >
              <ListItemIcon>
                <Cancel />
              </ListItemIcon>
              <ListItemText
                primary="Cancel"
                primaryTypographyProps={{ variant: "body2" }}
              />
            </MenuItem>
          )
        }
      </Menu>
    </>
  );
}
